export const KHACHHANG_THEMMOI = "KHACHHANG_THEMMOI";
export const KHACHHANG_THEMMOI_SUCCESS =
  "KHACHHANG_THEMMOI_SUCCESS";
export const KHACHHANG_THEMMOI_FAILURE =
  "KHACHHANG_THEMMOI_FAILURE";
